import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_General_Ledger_Account_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_GLACCT_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'GL Acct WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    GLACCOUNT_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'GL Acct Id', columnResourceName: 'colGLAcctId', alignment: HorizAlignment.Right}, domainOptions: { maxLength: 50}},
    GLACCOUNT_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

var GeneralLedgerAccountSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_GLACCT_ID',
        id_ui: 'GENERAL_LEDGER_ID',
        name:  'GENERAL_LEDGER_NAME'},


    searchProviderFields: vUI_General_Ledger_Account_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_General_Ledger_Account_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var GeneralLedgerAccountSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "GeneralLedgerAccountSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'GLACCOUNT_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'GLACCOUNT_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'GLACCOUNT_ID','GLACCOUNT_NAME', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: GeneralLedgerAccountSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

var GeneralLedgerAccountSearch: ISearch = {
    searchName: "Find General Ledger Account",
    renderOptions: { ui5ResourceId: "GeneralLedgerAccountSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [GeneralLedgerAccountSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("GeneralLedgerAccountBO", "GeneralLedgerAccount", GeneralLedgerAccountSearch, "General Ledger Account Search")

export {GeneralLedgerAccountSearch}